import { safePanic, type SearchListingsFilters } from '@ev-tech/search-modules-api';

import { type GetSearchResultPageUrlOptions } from './getSearchResultPageUrl';
import { getSearchResultPageLink } from './getSearchResultPageLink';
import { type AdditionalUiStateParams } from '../types/types';

export function createSerpUrl(params: {
  filters: SearchListingsFilters;
  options: GetSearchResultPageUrlOptions;
  additionalParams?: Record<string, unknown> & AdditionalUiStateParams;
  newPathname?: string;
}) {
  const { filters, options, additionalParams, newPathname } = params;

  if (typeof window === 'undefined') {
    return safePanic({ message: 'createSerpUrl should only be called on the client side', fallback: '' });
  }

  const currentUrl = new URL(window.location.href);

  if (newPathname) {
    currentUrl.pathname = newPathname;
  }

  const url = getSearchResultPageLink({
    url: currentUrl,
    filters,
    options,
    additionalParams,
  });

  return url;
}
